import { getContentByRef } from './get-content-by-ref.js';
import { getPageRoot } from './get-page-root.js';

const getReturnReasons = (pageModel)=>{
    var ref, ref1;
    if (!pageModel) {
        return;
    }
    const pageRoot = getPageRoot(pageModel);
    const ref2 = pageRoot === null || pageRoot === void 0 ? void 0 : (ref = pageRoot.models) === null || ref === void 0 ? void 0 : (ref1 = ref.returnsConfiguration) === null || ref1 === void 0 ? void 0 : ref1.$ref;
    const content = getContentByRef(ref2, pageModel);
    if (!content) {
        console.warn(`Cannot find content for Returns Configuration. Got: ${content} for $ref: ${ref2}`);
        return;
    }
    const reasons = content.data.keyValue.map(({ key , value  })=>{
        return {
            key,
            value
        };
    });
    return reasons;
};

export { getReturnReasons };
//# sourceMappingURL=get-return-reasons.js.map
